<template>
  <div>
    <vuestic-order-modal
      :large="true"
      :show.sync="show"
      ref="create-order-modal"
      class="create-order-modal"
      :okText="'modal.confirm2' | translate"
      :okClass="'btn btn-primary btn-micro'"
      :cancelClass="'btn btn-secondary btn-micro'"
      :cancelText="'modal.cancel2' | translate"
      @cancel="handleModalClose"
      @ok="handleModalOk"
      :closeIconShown="false"
    >
      <div slot="title">
        <div style="display:flex;align-items:center;">
          <b-img :src="require('@/assets/images/create-order-logo.svg')"></b-img>
          <span>{{ $t("t.createPaymentLink") }}</span>
        </div>
      </div>
      <el-form ref="form" label-width="120px">
        <div class="va-row">
          <div class="flex md12 w-100">
            <div class="label-title">{{ $t("t.customerEmail") }}</div>
            <div :class="{'has-error': errors.has('email'), 'valid': isFormFieldValid('email')}">
              <el-input
                clearable
                v-model="paymentLink.email"
                :placeholder="$t('t.customerEmail')"
                name="email"
                v-validate="'required|email'"
                data-vv-validate-on="change"
                required
              />
              <small v-show="errors.has('email')" class="help text-danger" >{{ errors.first('email') }}</small>
            </div>
          </div>
          <div class="flex md12 w-100 label-title switch-parent">
            <el-switch v-model="paymentLink.isSendEmail" active-color="#4AB2E3" inactive-color="#ABABAB" active-value="1" inactive-value="0"/>
            {{ $t("t.sendPaymentRequest") }}
          </div>
          <div class="flex md6 w-100">
            <div class="label-title">{{ $t('t.appID') }}</div>
            <div :class="{'has-error': errors.has('appId'), 'valid': isFormFieldValid('appId')}">
              <el-select
                class="w-100"
                filterable
                v-model="paymentLink.appId"
                :placeholder="$t('t.appID')"
                name="appId"
                v-validate="'required'"
                data-vv-validate-on="change"
                required
                @change="value => appIdChange(value)"
              >
                <el-option
                  v-for="(item,index) of appList"
                  :key="index"
                  :label="item.label"
                  :value="item.id"
                  class="order-select-option"
                ></el-option>
              </el-select>
              <small v-show="errors.has('appId')" class="help text-danger" >{{ errors.first('appId') }}</small>
            </div>
          </div>
          <div class="flex md6 w-100">
            <div class="label-title">{{ $t('t.country') }}</div>
            <div :class="{'has-error': errors.has('country'), 'valid': isFormFieldValid('country')}">
              <el-select
                class="w-100"
                filterable
                v-model="paymentLink.country"
                :placeholder="$t('t.country')"
                name="country"
                v-validate="'required'"
                data-vv-validate-on="change"
                required
                @change="() => { paymentLink.currency = '' }"
              >
                <el-option
                  v-for="item in countryOptions"
                  :key="item.id"
                  :value="item.value"
                  :label="item.label"
                  class="order-select-option"
                ></el-option>
              </el-select>
              <small v-show="errors.has('country')" class="help text-danger" >{{ errors.first('country') }}</small>
            </div>
          </div>
          <div class="flex md6 w-100">
            <div class="label-title">{{ $t('t.currency') }}</div>
            <div :class="{'has-error': errors.has('currency'), 'valid': isFormFieldValid('currency')}">
              <el-select
                class="w-100"
                filterable
                v-model="paymentLink.currency"
                :placeholder="$t('t.currency')"
                name="currency"
                v-validate="'required'"
                data-vv-validate-on="change"
                required
              >
                <el-option
                  v-for="item in currencyOptions"
                  :key="item.label"
                  :value="item.value"
                  :label="item.label"
                  class="order-select-option"
                ></el-option>
              </el-select>
              <small v-show="errors.has('currency')" class="help text-danger" >{{ errors.first('currency') }}</small>
            </div>
          </div>
          <div class="flex md6 w-100">
            <div class="label-title">{{ $t('t.amount') }}</div>
            <div :class="{'has-error': errors.has('amount'), 'valid': isFormFieldValid('amount')}">
              <el-input
                v-model="paymentLink.amount"
                clearable
                :placeholder="$t('t.amount')"
                name="amount"
                v-validate="'required|verifyRefundAmount'"
                data-vv-validate-on="change"
                required
                oninput="value=value.replace(/[^0-9.]+/g,'')"
              />
              <small v-show="errors.has('amount')" class="help text-danger" >{{ errors.first('amount') }}</small>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="flex md12 w-100" style="display:flex;padding-top:0;padding-bottom:0;    width: 100%;">
            <span class="label-title">{{ $t('t.total') }}</span><span class="label-title text-right">{{ paymentLink.currency }} {{ paymentLink.amount }}</span>
          </div>
          <div class="flex md12 w-100">
            <div class="label-title">{{ $t('t.expirationTime') }}</div>
            <div :class="{'has-error': errors.has('expirationTime'), 'valid': isFormFieldValid('expirationTime')}">
              <el-input
                v-model="paymentLink.expirationTime"
                clearable
                :placeholder="$t('payment.expireTime90Min')"
                name="expirationTime"
                v-validate="'required|verifyExpirationTime'"
                data-vv-validate-on="change"
                required
                oninput="value=value.replace(/[^0-9]+/g,'');value=Number(value);"
              />
              <small v-show="errors.has('expirationTime')" class="help text-danger" >{{ errors.first('expirationTime') }}</small>
            </div>
          </div>
          <div class="flex md12 w-100">
            <div class="label-title">{{ $t('t.describeWhat') }}</div>
            <div :class="{'has-error': errors.has('subject'), 'valid': isFormFieldValid('subject')}">
              <el-input
                type="textarea"
                :rows="2"
                :placeholder="$t('t.egPersonalized')"
                v-model="paymentLink.subject"
                name="subject"
                v-validate="'required'"
                data-vv-validate-on="change"
                maxlength="128"
                required
              />
              <small v-show="errors.has('subject')" class="help text-danger" >{{ errors.first('subject') }}</small>
            </div>
          </div>
          <div class="flex md12 w-100">
            <div class="label-title">{{ $t('t.listTheInvoices') }}</div>
            <div :class="{'has-error': errors.has('content'), 'valid': isFormFieldValid('content')}">
              <el-input
                type="textarea"
                :rows="2"
                :placeholder="$t('t.eg234569')"
                v-model="paymentLink.content"
                name="content"
                v-validate="'required'"
                data-vv-validate-on="change"
                maxlength="255"
                required
              />
              <small v-show="errors.has('content')" class="help text-danger" >{{ errors.first('content') }}</small>
            </div>
          </div>
        </div>
      </el-form>
    </vuestic-order-modal>

     <create-order-success-modal
      :large="true"
      :show.sync="show"
      ref="create-success-modal"
      class="create-success-modal"
      :okText="$t('t.newPayment') | translate"
      :okClass="'btn btn-primary btn-micro'"
      :cancelClass="'btn btn-secondary btn-micro'"
      :cancelText="'View payment list' | translate"
      :closeIconShown="false"
      @ok="handleSuccessOk"
      @close="handleSuccessClose"
     >
      <div slot="title">
        <div style="display:flex;align-items:center;">
          <b-img :src="require('@/assets/images/create-order-success.svg')"></b-img>
          <span style="font-size: 20px;margin-left: 3px;">{{ $t('t.paymentRequested') }}</span>
        </div>
      </div>
      <div class="create-success-content">
        <p v-if="Number(showEmailStatus) === 1">{{ $t('t.thePaymentLink') }} {{ showEmail }}</p>
        <p v-if="Number(showEmailStatus) === 1">{{ $t('t.youCanAslo') }}</p>
        <p v-if="Number(showEmailStatus) === 0">{{ $t('t.youCanCopy') }}</p>
        <el-input placeholder="" v-model="successLink" class="input-with-select" readonly>
          <el-button slot="append" :disabled="isCopySuccess" @click.prevent.stop="copyUrl">
            <b-img v-if="isCopySuccess" :src="require('@/assets/images/create-order-ok.svg')"></b-img>
            <span v-if="!isCopySuccess">{{ $t('t.copy') }}</span>
          </el-button>
        </el-input>
      </div>
     </create-order-success-modal>

		<div class="flex xs12 md6 flex-center" v-if="isToastContent">
			<div class="toasted-container sample-toasted-container shrink">
				<div class="toasted vuestic-toast none default">
					<i class="fa" :class="toastIcon" v-if="toastIcon" />
					{{toastText}}
				</div>
			</div>
		</div>
  </div>

</template>

<script>
import { request, guid } from "@/utils/utils.js";
import CreateOrderSuccessModal from "./CreateOrderSuccessModal.vue"

export default {
  name: 'createOrder',
  data() {
    this.$validator.extend('verifyRefundAmount', {
      validate: (value, ref) => {
        const reg = /(?!(^[0.]*$))((^[1-9]\d*$)|(?!(^0{2,}.))(?!(^0{1,}[1-9]+))(^[0-9]+.\d{1,2}$))/
        if (!reg.test(value)) {
          return false
        }
        return true
      },
      getMessage: (field) => 'The valid format should be 1234.56'
    })
    this.$validator.extend('verifyExpirationTime', {
      validate: (value, ref) => {
        if (value > 0) {
          return true
        } else {
          return false
        }
      },
      getMessage: (field) => 'The ' + field + ' is not valid.'
    })
    return {
      show: true,
      paymentLink: {
        mtNO: '',
        email: '',
        isSendEmail: '0',
        appId: '',
        country: '',
        currency: '',
        amount: 0,
        expirationTime: '',
        subject: '',
        content: '',
      },
      successLink: '',
      isCopySuccess: false,
      countryCurrencyData: [],
      showEmail: '',
      showEmailStatus: 0,
      // toast
      isToastContent: false,
      toastIcon: 'fa-eercast',
      toastText: 'App has been created and completed!',
      toastPosition: 'top-center',
      isToastFullWidth: false,
      toastDuration: 2500
    }
  },
	created() {
		// this.$set(this.paymentLink, "mtNO", guid());
	},
  mounted() {
    // this.$refs['create-success-modal'].open()
  },
  methods: {
    handleModalClose() {
      this.resetPaymentLink()
      this.$validator.reset()
    },
    handleSuccessOk() {
      this.showEmail = ''
      this.showEmailStatus = 0
      this.successLink = ''
      this.$emit('newPayment')
    },
    handleSuccessClose() {
      this.showEmail = ''
      this.showEmailStatus = 0
      this.successLink = ''
      this.$emit('close')

    },
    handleModalOk (callback) {
      this.$validator.validateAll().then(result => {
        // callback()
        if (result) {
          this.loadingFullScreen("submitLoading", "Searching", "fa fa-hourglass-half");
					let token = localStorage.getItem('Authorization')
					let that = this;
					request({
						method: 'post',
						url: 'api/dashboard/order/generate?&access_token=' + token + '',
						data: {
							'out_trade_no': guid(),
							'email': this.paymentLink.email,
							'notification': Number(this.paymentLink.isSendEmail),
							'app_id': this.paymentLink.appId,
							// 'country': this.paymentLink.country,
							'currency': this.paymentLink.currency,
							'amount': this.paymentLink.amount,
							'timeout_express': this.paymentLink.expirationTime,
							'subject': this.paymentLink.subject,
							'content': this.paymentLink.content,
							'return_url': this.paymentLink.returnUrl,
              'regions': this.paymentLink.country
						},
						headers: {
							'Content-Type': 'application/json'
						}
					}).then(resp => {
						this.submitLoading.close();
						let res = resp.data;
						if(res.code === '10000') {
							if(res.msg === 'Success') {
                this.$nextTick (function () {
									this.successLink = res.data;
                  this.$refs['create-order-modal'].close();
                  this.$refs['create-success-modal'].open()
                  this.showEmail = this.paymentLink.email
                  this.showEmailStatus = Number(this.paymentLink.isSendEmail)
                  this.resetPaymentLink()
                  this.$validator.reset()
                })
							} else {
								this.$message.error('msg: ' + res.msg);
							}
						} else {
							const { msg = '', sub_msg = '' } = res
							this.$message.error('msg：'+ res.msg + ', \n' + msg + ', ' + sub_msg);
						}
					})
        }  else {
					this.$message.error("Please fill in all the required fields");
					return false;
				}
      })
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
					this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    launchToast () {
      this.isToastContent = true
      this.showToast(this.toastText, {
        icon: this.toastIcon,
        position: this.toastPosition,
        duration: this.toastDuration,
        fullWidth: this.isToastFullWidth
      })
      this.isToastContent = false
    },
		loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    appIdChange (value) {
      this.paymentLink.country = ''
      this.paymentLink.currency = ''
      // this.$set(this.dynamicValidateForm, "appId", this.appList[0].id);
      if (!value) { return; }
			let access_token = localStorage.getItem("Authorization");
			let url = `/api/dashboard/order/app-country-currency?app_id=${value}`;
			this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
			request({
				method: "post",
				url,
        params: { access_token },
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
			}).then((res) => {
        const { code, data} = res.data
        if (code === "10000") {
          this.countryCurrencyData = data
        }
				this.searching.close();
			}).catch(() => this.searching.close());
    },
    copyUrl() {
      const that = this
			const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', this.successLink);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$message({
          showClose: true,
          message: 'Copied Successfully',
          type: 'success',
          duration: 2500
        });
        that.isCopySuccess = true
        setTimeout(() => {
          that.isCopySuccess = false
          // that.$refs['create-success-modal'].close()
          // that.toastText = 'Copy Success'
          // that.launchToast()
        }, 1200);
      }
      document.body.removeChild(input);
		},
    resetPaymentLink () {
      this.paymentLink = {
        mtNO: '',
        email: '',
        isSendEmail: '0',
        appId: '',
        country: '',
        currency: '',
        amount: 0,
        expirationTime: '',
        subject: '',
        content: '',
      }
    }
  },
  computed: {
    countryOptions () {
      let countryArray = []
      if (this.countryCurrencyData.length > 0) {
        this.countryCurrencyData.forEach(item => {
          countryArray.push({ label: item.country, value: item.country })
        })
        this.paymentLink.country = countryArray[0] ? countryArray[0].value : ''
        return countryArray
      }
      return countryArray
    },
    currencyOptions () {
      let currencyArray = []
      if (this.countryCurrencyData.length > 0 && this.paymentLink.country) {
        const countryCurrencyItem = this.countryCurrencyData.filter(item => item.country === this.paymentLink.country)[0]
        if (countryCurrencyItem) {
          currencyArray = countryCurrencyItem[this.paymentLink.country]
          currencyArray = currencyArray ? currencyArray.map(item=> { return {"label": item,"value": item} }) : []
        }
        this.paymentLink.currency = currencyArray[0] ? currencyArray[0].value : ''
        return currencyArray
      }
      return currencyArray
    }
  },
  props: {
    appList: {
      type: Array,
      default: () => []
    }
  },
  components: { CreateOrderSuccessModal }
}
</script>

<style lang="scss">
.create-order-modal {
  font-family: SpaceGrotesk-Regular;
  color: #141414;
  .modal-dialog {
    border-radius: 24px;
  }
  .modal-title {
    margin: 0 auto;
  }
  .modal-content {
    border-radius: 24px;
  }
  .vuestic-vertical-center-modal {
    align-items: unset!important;
  }
  .w-100 {
    width: 100%;
  }
  .modal-lg {
    width: 837px;
    margin-top: 20px;
    height: fit-content;
  }
  .el-divider {
    margin: 6px 0;
  }
  .label-title {
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 500;
  }
  .modal-header {
    font-size: 20px;
    img {
      width: 20px;
      height: auto;
      margin-right: 3px;
    }
  }
  .switch-parent {
    display:flex;
    align-items:center;
    flex:0.5 1 100%;
    .el-switch {
      flex: unset;
      margin-right: 12px;
    }
  }
  input[type='text'] {
    color: rgba(20, 20, 20, 0.9);
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color:#FFFFFF;
    border-radius: 12px;
    height: 42px;
    font-size: 14px;
    font-weight: 500;
    padding: 12px 0 12px 24px;
  }
  input[type='text']:placeholder-shown, textarea:placeholder-shown {
    color: rgba(20, 20, 20, 0.9);
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
  }
  input[type='text']::placeholder, textarea::placeholder {
    font-size: 14px;
    font-weight: 500;
  }
  textarea {
    color: rgba(20, 20, 20, 0.9);
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color:#FFFFFF;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    padding: 12px 0 12px 24px;
  }
  .modal-footer {
    flex-wrap: nowrap;
    font-size: 14px;
    button:nth-of-type(1) {
      font-size: 14px;
      color: rgba(20, 20, 20, 0.8);
      background-color: #FFFFFF;
      border:1px solid rgba(0, 0, 0, 0.2);
      padding: 10px 60.25px;
      border-radius: 12px;
      text-transform:capitalize;
      &:hover {
        color: rgba(20, 20, 20, 0.8)!important;
        background-color: rgba(239, 239, 239, 0.9)!important;
        border: 1px solid rgba(0, 0, 0, 0.2)!important;
      }
      &:focus {
        color: rgba(20, 20, 20, 0.8)!important;
        background-color: rgba(239, 239, 239, 0.9)!important;
        border: 1px solid rgba(0, 0, 0, 0.2)!important;
      }
      &:active {
        color: rgba(20, 20, 20, 0.8)!important;
        background-color: rgba(239, 239, 239, 0.9)!important;
        border: 1px solid rgba(0, 0, 0, 0.2)!important;
      }
    }
    button:nth-of-type(2) {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      background-color: rgba(74, 178, 227, 1)!important;
      padding: 12px 62.25px;
      border-radius: 12px;
      text-transform:capitalize;
      box-shadow: unset;
      &:hover {
        background-color: #4AB2E3!important;
        padding: 12px 62.25px;
      }
      &:foucs {
        background-color: #4AB2E3!important;
        padding: 12px 62.25px;
      }
      &:active {
        background-color: #4AB2E3!important;
        padding: 12px 62.25px;
      }
    }
  }
}

.el-select-dropdown__list {
  padding: 0;
}
.order-select-option {
  font-size: 14px;
  font-weight: 500;
  background: #FFFFFF!important;
  height: 42px;
  line-height: 42px;
  padding: 0 24px;
}
.order-select-option.selected {
  background: rgba(74, 178, 227, 0.7)!important;
}
.order-select-option.hover, .order-select-option:hover {
  background: rgba(74, 178, 227, 0.7)!important;
}

.create-success-modal {
  .modal-title {
    margin: 0 auto;
  }
  .modal-lg {
    width: 637px;
    height: fit-content;
  }
}
.create-success-content {
  font-family: SpaceGrotesk-Regular;
  color: #141414;
  p {
    font-size: 14px;
    font-weight: 500;
    line-height: 17.86px;
    text-align: center;
    padding: 0;
    margin: 0;
  }
  .el-input {
    margin-top: 24px;
    .el-input-group__append {
      border: none;
    }
    button {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      background-color: rgba(74, 178, 227, 1);
      padding: 12px 24px;
      border-radius: 12px;
      text-transform:capitalize;
      box-shadow: unset;
      &:hover {
        background-color:#4AB2E3!important;
      }
      &:foucs {
        background-color:#4AB2E3!important;
      }
      &:active {
        background-color:#4AB2E3!important;
      }
    }
  }
}
.create-success-modal {
  .modal-footer {
    flex-wrap: nowrap;
    font-size: 14px;
    button:nth-of-type(1) {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      background-color: rgba(74, 178, 227, 1)!important;
      padding: 12px 62.25px;
      border-radius: 12px;
      text-transform:capitalize;
      box-shadow: unset;
      &:hover {
        background-color: #4AB2E3!important;
        padding: 12px 62.25px;
      }
      &:foucs {
        background-color: #4AB2E3!important;
        padding: 12px 62.25px;
      }
      &:active {
        background-color: #4AB2E3!important;
        padding: 12px 62.25px;
      }
    }
  }
}
</style>
